import React from 'react'
import classNames from 'classnames'
import * as styles from './styles.less'

export default function Divider({ className }) {
  return (<hr className={classNames(styles.divider, className)}/>)
}
